export default "__VITE_ASSET__CvNOwu9p__"